module.exports = __webpack_public_path__ + "img/hydroscopic-absorption-black.99b53e0.svg";